import { render, staticRenderFns } from "./StandardTable.vue?vue&type=template&id=0e68a863&lang=pug"
import script from "./StandardTable.vue?vue&type=script&lang=js"
export * from "./StandardTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports